import restApi from "@plannel/services/utils/rest-api";

const getAll = (params) => {
  return restApi.post("/api/customer-item", params);
};

const getAllForCSV = params => {
  return restApi.post("/api/customer-item/csv", params);
};

const get = id => {
  return restApi.get(`/api/customer-item/${id}`);
};

// 예측(BF) 대상 거래처-품목 조합 수 — { count } (홈 파이프라인 "예측(BF)" 단계용, COUNT 집계만)
const getBfTargetCount = () => {
  return restApi.get("/api/customer-item/bf-target-count");
};

// 수요계획 대상 거래처-품목 조합 수 — { count } (홈 파이프라인 "수요계획" 단계용, COUNT 집계만)
const getDpTargetCount = () => {
  return restApi.get("/api/customer-item/dp-target-count");
};

const getByPostn = (params) => {
  return restApi.get("/api/customer-item/postn", { params });
};

const getByHrchyCds = (params) => {
  return restApi.get("/api/customer-item/hrchys", { params });
};

const upsert = data => {
  return restApi.post("/api/customer-item/save", data);
};

const remove = ids => {
  return restApi.delete(`/api/customer-item/${ids}`);
};

const getCustomerOrHrchy = (params) => {
  return restApi.get("/api/customer-item/customer", { params });
};

const getNpiCombo = data => {
  return restApi.post("/api/customer-item/npis", data);
};

const customerItemService = {
  getAll,
  getAllForCSV,
  get,
  getBfTargetCount,
  getDpTargetCount,
  getByPostn,
  getByHrchyCds,
  upsert,
  remove,
  getCustomerOrHrchy,
  getNpiCombo
};

export default customerItemService;